// extracted by mini-css-extract-plugin
export default {"header":"plans-carousel-module--header--05c0a"};